import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/shared/user.service';

@Component({
  selector: 'app-partials',
  templateUrl: './partials.component.html',
  styleUrls: ['./partials.component.scss']
})
export class PartialsComponent implements OnInit {
  isExpanded: boolean = false;
  year;
  menuWidthOpen: string = '14%';
  menuWidthClosed: string = '56px';
  constructor(public userService: UserService) {
    this.userService.currentURL = window.location.pathname;
  }

  getHeaderWidth(): string {
    return this.isExpanded ? `calc(100% - ${this.menuWidthOpen})` : `calc(100% - ${this.menuWidthClosed})`;
  }

  getFooterWidth(): string {
    return this.isExpanded ? `calc(100% - ${this.menuWidthOpen})` : `calc(100% - ${this.menuWidthClosed})`;
  }

  openMenu() {
    const menuContent = document.querySelector('.mat-mdc-menu-panel');
    if (menuContent) {
      this.isExpanded ? menuContent.classList.add('menu-content-open') : menuContent.classList.add('menu-content-closed');
    }
  }

  ngOnInit() {
    this.year = new Date().getFullYear()
  }

  logout() {
    this.userService.signOutOfUsernamePassword(window.location.pathname);
  }

  getOrganizationLogo(): string {
    if (!this.userService.loggedInOrg) {
      return '../../../assets/img/Logo.svg';
    }
    
    if (this.userService.loggedInOrg.logoUrl) {
      return this.userService.loggedInOrg.logoUrl;
    }
    
    // Fall back to orgLogo (old format - could be URL or base64)
    if (this.userService.loggedInOrg.orgLogo) {
      // Check if orgLogo is already a URL
      if (this.userService.loggedInOrg.orgLogo.startsWith('http://') || 
          this.userService.loggedInOrg.orgLogo.startsWith('https://')) {
        return this.userService.loggedInOrg.orgLogo;
      }
      // Otherwise treat as base64
      return `data:image/png;base64,${this.userService.loggedInOrg.orgLogo}`;
    }
    
    // Default logo
    return '../../../assets/img/Logo.svg';
  }

}

